import fetch, { fetchJson } from 'utils/fetch';

export const fetchResources = (page, resourceType, folder, filter) => {
  let url = `/bucket/resources.json?page=${page}&resource_type=${resourceType}`;
  if (folder) {
    url += `&folder=${folder}`;
  }
  if (filter) {
    url += `&filter=${filter}`;
  }

  return fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(res => {
    // TODO: Use a regex
    const contentRange = res.headers.get('Content-Range');

    const total = contentRange.split('/')[1];
    const [offset, limit] = contentRange.split('/')[0].split('-');

    return res.json().then(resources => ({
      resources,
      total: parseInt(total, 10),
      offset: parseInt(offset, 10),
      limit: parseInt(limit, 10),
    }));
  });
};

export const fetchFolders = () => fetchJson('/bucket/folders.json');



// WEBPACK FOOTER //
// ./src/shared/components/ResourceSelector/api/index.js